/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Access_Conflicts_Section_TeamsInputs */



/**
* | output |
* | --- |
* | "Teams with Missing Access" |
*
* @param {Project_Access_Conflicts_Section_TeamsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_conflicts_section_teams = /** @type {((inputs?: Project_Access_Conflicts_Section_TeamsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Conflicts_Section_TeamsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teams mit fehlendem Zugriff")
	return /** @type {LocalizedString} */ ("Teams with Missing Access")
});